import type {SiteStatusSimple} from '@/types/api';

const ALL_STEPS = [
    'queue',
    'validate',
    'create_database',
    'grant_permissions',
    'create_tables',
    'lock_failed',
    'timeout',
    'unknown',
    'seed_fixtures',
    'seed_settings',
    'assign_plan',
    'provision_api_credentials',
    'activate',
    'send_welcome'
] as const;

export function ProvisioningSteps({siteStatus}: { siteStatus: SiteStatusSimple }) {
    const completedCount = ALL_STEPS.filter((stepKey) => {
        const idx = ALL_STEPS.indexOf(stepKey);
        const currentIdx = ALL_STEPS.indexOf(siteStatus.provisioning_step as typeof ALL_STEPS[number]);
        if (siteStatus.status === 'active') {
            return true;
        }
        return currentIdx >= 0 && idx < currentIdx;
    }).length;
    const totalSteps = ALL_STEPS.length;
    const progress = siteStatus.status === 'active'
        ? 100
        : Math.min(((completedCount + 0.5) / totalSteps) * 100, 95);

    return (
        <div>
            <div
                style={{
                    height: 6,
                    background: '#F4F5F6',
                    borderRadius: 3,
                    overflow: 'hidden'
                }}
            >
                <div
                    style={{
                        height: '100%',
                        width: `${progress}%`,
                        background: siteStatus.status === 'failed'
                            ? '#F50B23'
                            : siteStatus.status === 'active'
                                ? '#30CF43'
                                : 'linear-gradient(90deg, #30CF43, #EF5A2B)',
                        borderRadius: 3,
                        transition: 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                    }}
                />
            </div>
        </div>
    );
}
